export enum DocumentStatus {
    Active = 0,
    Archived = 1,
    Uploaded = 2,
    ParsingError = 3,
    InProofreading = 4,
    ProofreadingComplete = 5,
}